export default "__VITE_ASSET__5553e16f__"